MOBILE_WIDTH_TRESHOLD = 750;
$(document).ready(function() {

    $('.open-menu-burger-item-container').click(function() {
        var _this = $(this).find('.open-menu-burger-item');

        var _nav_id = $(_this).data('id');
        if($(_this).hasClass('active'))
        {
            $('#' + _nav_id).slideUp();
            $(_this).removeClass('active');
            $(_this).html('<i class="fa-solid fa-chevron-down"></i>');
        }
        else
        {
            $('#' + _nav_id).slideDown();
            $(_this).addClass('active');
            $(_this).html('<i class="fa-solid fa-times"></i>');
        }
    });

    $('.open-menu-burger-item-children').click(function() {
        var _id = $(this).data('id');
        if($(this).hasClass('opened'))
        {
            $('#menu-burger-item-children-' + _id).slideUp();
            $(this).removeClass('opened');
            $(this).html('<i class="fa-solid fa-chevron-down"></i>');
        }
        else
        {
            $('#menu-burger-item-children-' + _id).slideDown();
            $(this).addClass('opened');
            $(this).html('<i class="fa-solid fa-times"></i>');
        }
    });

    $('.menu-btn').click(function() {
        $('.main-nav').addClass('active');
        $('#menu-main-menu').addClass('active');
    });

    $('.close-menu').click(function() {
        $('.main-nav').removeClass('active');
        $('#menu-main-menu').removeClass('active');
    });

    $('.menu-item-has-children').click(function() {
        if($(this).find('>ul').hasClass('menu-list-active')){
            return false;
        }

        // $(this).children('.dropdown').toggleClass('active');
        // $(this).children('.sub-menu').toggleClass('active');
        $(this).toggleClass('active');
    });
/*
    $('.menu-item').click(function() {
        return false;
    });
*/
    $('.filter-head').click(function() {
        $(this).toggleClass('active');
        $('.search-bar').toggleClass('active');
        $('.category-filters').toggleClass('active');
    });

    $(window).bind('hashchange', function() {
        var hash = document.location.hash;
        var hash = hash.replace('#', '');

    });
    window.onload = function() {
        var hash = (window.location.hash).replace('#', '');

    }
    if (location.href.indexOf("#") != -1) {
            var hash = window.location.hash.substring(1);
            var hash = hash.replace('#', '');
    }

    if (typeof window.location.search.substr(1) != "undefined") {
        if (window.location.search.substr(1) === "book-a-table") {
            $('#table-book-old').addClass('active');
        }
    }

    $('.close-iframe').click(function() {
        $('.table-book-wrap').removeClass('active');
    });

    $('.close-popup').click(function() {
        $('.popup-wrap').removeClass('enable-popup');
    });

    let lastScrollTop = 0;
    let scrollTop = 0;
    if($('body').hasClass('page-wired'))
    {
        /**
         * For Wired Media Website
         * the scrolled-nav class will be added when user scrolls up
         * added by: ivan.simoy
         * **/

        let SCROLL_THRESHOLD = 30;
        $(window).scroll(function ()
        {
            scrollTop = $(window).scrollTop();

            if(SCROLL_THRESHOLD < scrollTop){
                $('.page-head').addClass('scrolled-nav');
            }
            else{
                if(!$('.header-wired').hasClass('mega-menu-open')){
                    /** remove only if mega menu is not opened **/
                    $('.page-head').removeClass('scrolled-nav');
                }
            }

            lastScrollTop = scrollTop;
        });
    }
    else if(!$('body').hasClass('prestige'))
    {
        let SCROLL_THRESHOLD = 30;
        $(window).scroll(function ()
        {
            scrollTop = $(window).scrollTop();

            if (scrollTop < lastScrollTop) {
                $('.page-head').removeClass('scrolled-nav');
            }
            else if (scrollTop >= SCROLL_THRESHOLD) {
                $('.page-head').addClass('scrolled-nav');
            }

            lastScrollTop = scrollTop;
        });
    }
    else
    {
        let SCROLL_THRESHOLD = 90;
        $(window).scroll(function ()
        {
            scrollTop = $(window).scrollTop();

            if (scrollTop < lastScrollTop) {
                $('.page-head').removeClass('scrolled-nav');
            }
            else if (scrollTop >= SCROLL_THRESHOLD) {
                $('.page-head').addClass('scrolled-nav');
            }

            lastScrollTop = scrollTop;
            reveal();
        });
        scrollTop = $(window).scrollTop();

        if (scrollTop < lastScrollTop) {
            $('.page-head').removeClass('scrolled-nav');
        }
        else if (scrollTop >= SCROLL_THRESHOLD) {
            $('.page-head').addClass('scrolled-nav');
        }

        $('.flexible-content-wrap-premium.prestige').children().eq(1).find('.reveal').each((k,v) =>{
            $(v).removeClass('reveal');
        });
        $('.flexible-content-wrap-premium.prestige').children().eq(1).find('.reveal-no-fade').each((k,v) =>{
            $(v).removeClass('reveal-no-fade');
        });

        lastScrollTop = scrollTop;
        reveal();
    }

    $('.form-close').click(function() {
        $('.hero-popup').removeClass('active');
    });

    if($('body').hasClass('premium')) {
        if(!$('body').hasClass('prestige')) {
            checkTop();
        }

        if($('.vimeo').length > 0){
            checkVimeo();
        }
    }

    $('button[name="add-to-cart"]').on('click', function(){
        fbq('track', 'AddToCart');
    });

    $('a.checkout-button').on('click', function(){
        fbq('track', 'InitiateCheckout');
    });

    $('.mobile-carousel').each((k, v) => {
        $(v).slick({
            arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            cssEase: 'linear',
            speed: 2000,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnFocus: false,
            adaptiveHeight: false,
            fade: true
        });
    });

    /** JS for Generic Pager - Start **/
    $('.pager-container > .pager-select').change(function() {
        var _slug = $(this).data('slug');
        var _page = $(this).val();
        location.href = '/' + _slug + '/page/' + _page;
    });

    $('.pager-container > .pager-start').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        location.href = '/' + _slug ;
    });

    $('.pager-container > .pager-prev').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').val();
        _page--;
        location.href = '/' + _slug + '/page/' + _page;
    });

    $('.pager-container > .pager-next').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').val();
        _page++;
        location.href = '/' + _slug + '/page/' + _page;
    });

    $('.pager-container > .pager-end').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').data('maxpage');
        location.href = '/' + _slug + '/page/' + _page;
    });
    /** JS for Generic Pager - End **/

    initBlogFilterEvents();
    wiredMediaEventHandlers();
    initFooterItemsEvents();

    if($('#CybotCookiebotDialogPoweredbyImage').length > 0){
        $('#CybotCookiebotDialogPoweredbyImage').attr("height", 30);
        $('#CybotCookiebotDialogPoweredbyImage').attr("width", 23);
    }
});

function initFooterItemsEvents()
{
    $('.footer-items-show-more').click(function() {
        $(this).prev('ul').removeClass('footer-items-limit-display');
        $(this).removeClass('footer-items-show-more').addClass('footer-items-show-less');
        $(this).html("show less...");
        initFooterItemsEvents();
    });

    $('.footer-items-show-less').click(function() {
        $(this).prev('ul').addClass('footer-items-limit-display');
        $(this).removeClass('footer-items-show-less').addClass('footer-items-show-more');
        $(this).html("show more...");
        console.log("here");
        initFooterItemsEvents();
    });
}

function unloadScrolledNav(){
    scrollTop = $(window).scrollTop();
    let SCROLL_THRESHOLD = 30;

    if(scrollTop <= SCROLL_THRESHOLD){
        $('.page-head').removeClass('scrolled-nav');
    }
}

function alignContentHeight(){
    var IMG_PADDING = '3rem';

    //-- no need to align left and right columns since WIRED-72 change
//     $('.two-column-image-text-cta-block').each(function(){
//         var _width_left = $(this).find('.col-left').width();
//         var _height_right = $(this).find('.col-right').height();

//         if($('#hdn_mobile_platform').val() == "true"){
//             if($(this).find('.col-left > img').length > 0){
// //                $(this).find('.col-left > img').css('padding-top',IMG_PADDING);
// //                $(this).find('.col-left > img').css('padding-bottom',IMG_PADDING);
//             }
//             else if(_width_left < 550){
//                 $(this).find('.col-left').height(165);
//             }
//             else{
//                 $(this).find('.col-left').height(125);
//             }
//         }
//         else{
//             $(this).find('.col-left').height(_height_right + 18);
//         }
//     });

    if($('#hdn_mobile_platform').val() == "true"){
        /** do not adjust height on mobile **/
        return false;
    }

    setTimeout(function(){
        /** script to align heading, paragraph content in blocks - start **/
        var _block_names = [];
        _block_names.push('global-three-column-content-block-list');
        _block_names.push('three-column-content-block-list');
        // _block_names.push('blogs-sliders-latest');

        $.each(_block_names, function( index, value ) {
            $('.' + value).each(function(){
                var _height_heading = 39;
                var _height_paragraph = 102;
                var _this = this;
                $(_this).find('.card-wrapper').each(function(){
                    $(this).find('.heading').removeAttr('style');
                    $(this).find('.paragraph').removeAttr('style');

                    if($(this).find('.heading').height() > _height_heading){
                        _height_heading = $(this).find('.heading').height();
                    }

                    if($(this).find('.paragraph').height() > _height_paragraph){
                        _height_paragraph = $(this).find('.paragraph').height();
                    }
                });

                $(_this).find('.card-wrapper').each(function(){
                    $(this).find('.heading').height(_height_heading);

                    $(this).find('.paragraph').height(_height_paragraph);
                });
            });
        });
        /** script to align heading, paragraph content in blocks - end **/
    }, 1200);
}

var _iframe_lazy = true;
function loadIframeLazy(){
    if(_iframe_lazy){
        _iframe_lazy = false;
        if($('.video-snippet').length > 0){
            var _iframe_code = $('.video-snippet').html();
            var _iframe_clean = _iframe_code.toString()
                                            .replace('<lazy_iframe', '<iframe')
                                            .replace('/lazy_iframe>', '/iframe>')
                                            .replace('<lazy_script', '<script')
                                            .replace('/lazy_script>', '/script>');

            $('.video-snippet').parent().html(_iframe_clean);
        }
    }
}

function wiredMediaEventHandlers(){
    alignContentHeight();
    $( window ).on( "resize", function() {
        alignContentHeight();
    });

    $('.filter_category_dropdown').unbind('click');
    $('.filter_category_dropdown').click(function() {
        var _href = $(this).val();
        if(_href != '' && _href != undefined){
            location.href = _href;
        }
        return false;
    });

    $('.custom-anchor-tag').unbind('click');
    $('.custom-anchor-tag').click(function() {
        var _href = $(this).data('href');
        if(_href != '' && _href != undefined){
            location.href = _href;
        }
        return false;
    });

    $(document).on("mousemove", function(){
        loadIframeLazy();
    });

    $(document).on("mouseenter", function(){
        loadIframeLazy();
    });

    $('.video-thumbnail').unbind('click');
    $('.video-thumbnail').click(function() {
        loadIframeLazy()
    });

    /** JS for Blogs Sliders (Latest) - start **/
    if($('.blogs-sliders-latest').length)
    {
        const slides = $('.blogs-sliders-latest-list');
        $(slides).slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            initialSlide: 1,
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            arrows: true,
            prevArrow: ".slider-prev-blogs",
            nextArrow: ".slider-next-blogs",
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        arrows: false
                    }
                }
            ]
        });
    }
    /** JS for Blogs Sliders (Latest) - end **/

    /** JS for Logo Marquee Block - start **/
    if($('.logo-marquee-block').length)
    {
        const slides = $('.logo-marquee-block-list');
        $(slides).slick({
            speed: 5000,
            autoplay: true,
            autoplaySpeed: 0,
            centerMode: true,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            buttons: false,
            pauseOnHover: false,
            responsive: [
                {
                  breakpoint: 550,
                  settings: {
                    speed: 2500,
                  }
                }
            ]
        });
    }
    /** JS for Logo Marquee Block - end **/

    /** JS for Logo Marquee Block (Post Type) - start **/
    if($('.logo-marquee-block-post-type').length)
    {
        const slides = $('.logo-marquee-block-post-type-list');
        $(slides).slick({
            speed: 5000,
            autoplay: true,
            autoplaySpeed: 0,
            centerMode: true,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 3,
            arrows: false,
            buttons: false,
            pauseOnHover: false,
            responsive: [
                {
                  breakpoint: 550,
                  settings: {
                    speed: 2500,
                  }
                }
            ]
        });
    }
    /** JS for Logo Marquee Block (Post Type) - end **/

    /** JS for Testimonials Single - start **/
    if($('.testimonials-single:not(.count-1)').length)
    {
        const slides = $('.testimonials-single-list');
        $(slides).slick({
            speed: 300,
            autoplay: true,
            autoplaySpeed: 8000,
            centerMode: true,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            pauseOnHover: true
        });
    }
    /** JS for Testimonials Single - end **/

    /** JS for Testimonials Sliders (Latest) - start **/
    if($('.testimonials-sliders-latest').length)
    {
        const slides = $('.testimonials-sliders-latest-list');
        $(slides).slick({
            speed: 300,
            autoplay: true,
            autoplaySpeed: 8000,
            centerMode: true,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            dots: false,
            arrows: true,
            prevArrow: ".slider-prev-testimonials",
            nextArrow: ".slider-next-testimonials",
            pauseOnHover: true,
            responsive: [
                {
                  breakpoint: 550,
                  settings: {
                    arrows: false,
                    dots: true
                  }
                }
            ]
        });
    }
    /** JS for Testimonials Sliders (Latest) - end **/

    /** JS for FAQ Accordion Block - start **/
    $('.faq_row').click(function() {
        if($(this).hasClass('active')){
            $(this).removeClass('active');
            $(this).children('.paragraph').slideUp();
        }
        else{
            $(this).addClass('active');
            $(this).children('.paragraph').slideDown();
        }
    });
    /** JS for FAQ Accordion Block - end **/

    /** JS for Three Column Expanding CTA Slider - start **/
    if($('.three-column-expanding-cta-slider').length)
    {
        const slides = $('.three-column-expanding-cta-slider-list');
        $(slides).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            // initialSlide: 1,
            dots: false,
            infinite: false,
            centerMode: true,
            focusOnSelect: true,
            arrows: true,
            prevArrow: ".slider-prev-three-column-expanding-cta",
            nextArrow: ".slider-next-three-column-expanding-cta"
        });
    }
    /** JS for Three Column Expanding CTA Slider - end **/

    /** JS for Two Column Image + Text CTA Slider Block - start **/
    if($('.two-column-image-text-cta-slider-block').length > 0)
    {
        $('.two-column-image-text-cta-slider-block > .section__shell > .section__nav').each(function(){
            var _slider_nav = $(this).data('slider_nav');
            var _slider_for = $(this).data('slider_for');

            $('.' + _slider_nav).slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: '.' + _slider_for,
                dots: false,
                arrows: false,
                centerMode: true,
                focusOnSelect: true,
                responsive: [
                    {
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    }
                ]
            });

            $('.' + _slider_for).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                // fade: true,
                asNavFor: '.' + _slider_nav
            });
        });
    }
    /** JS for Two Column Image + Text CTA Slider Block - start **/

    /** JS for Three Column Expanding CTA Block - start */
    if(window.innerWidth < 550) {
        const slides = $('.three-column-expanding-cta-block > .section__shell > .section__content');
        $(slides).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            infinite: false,
            centerMode: true,
            focusOnSelect: true,
            arrows: false
        });
    }

    if(window.innerWidth >= 0 && window.innerWidth <= 1100) {
        $('.three-column-expanding-cta-block > .section__shell > .section__content .section__column').unbind('click');
        $('.three-column-expanding-cta-block > .section__shell > .section__content .section__column').click(function() {
            var _this = this;
            var _active = true;
            if($(_this).hasClass("active")){
                _active = false;
            }

            $('.three-column-expanding-cta-block > .section__shell > .section__content .section__column').each(function(){
                $(this).removeClass("active");
            });

            if(_active){
                $(_this).addClass("active");
            }

            return false;
        });
    }
    /** JS for Three Column Expanding CTA Block - end */

    /** JS for Three Column Zoom-in CTA Block - start */
    if(window.innerWidth < 550) {
        const slides = $('.three-column-zoom-in-cta-block > .section__shell > .section__content');
        $(slides).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            infinite: false,
            centerMode: true,
            focusOnSelect: true,
            arrows: false
        });
    }
    /** JS for Three Column Zoom-in CTA Block - end */

    /** JS for Three Column Slide-down CTA Block - start */
    if(window.innerWidth < 550) {
        const slides = $('.three-column-slide-down-cta-block > .section__shell > .section__content');
        $(slides).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            infinite: false,
            centerMode: true,
            focusOnSelect: true,
            arrows: false
        });
    }
    /** JS for Three Column Slide-down CTA Block - end */

    /** JS for Blog Page - start **/
    if($('.filter_category_trigger').length)
    {
        $('.filter_category_trigger').unbind('click');
        $('.filter_category_trigger').click(function() {
            var _this = this;
            $('.filter_category').each(function(){
                $(this).removeClass('active');
            });

            $(_this).addClass('active');
            $('#blog_filter_button').click();
        });
    }
    /** JS for Blog Page - end **/

    /** JS for mobile-menu-toggle - start */
    $('.mega-toggle-animated-box').unbind('click');
    $('.mega-toggle-animated-box').click(function() {
        showMenu();
        $('.mega-menu-toggle').removeClass('mega-menu-open');
        return false;
    });

    $('.mega-menu-toggle').unbind('click');
    $('.mega-menu-toggle').click(function() {
        showMenu();
        $('.mega-menu-toggle').removeClass('mega-menu-open');
        return false;
    });

    $('.mega-toggle-animated').unbind('click');
    $('.mega-toggle-animated').click(function() {
        $('.mega-menu-toggle').removeClass('mega-menu-open');
        return false;
    });
    /** JS for mobile-menu-toggle - end */

    /** JS for customize mega menu for desktop - start */
    setTimeout(function(){
        var _menu_ads_content = $('.menu-ads-block-hidden-container').html();
        $('.mega-menu-wrap > ul > li > ul').each(function() {
            if($('#hdn_logged_in_user').length > 0 && $('#hdn_logged_in_user').val() == "true"){
                $(this).addClass('logged-in-user');

                $('.page-head').addClass('logged-in-user');
                $('.menu-overlay').addClass('logged-in-user');
            }

            $(this).prepend('<li class="menu-ads-block-floating-container">' + _menu_ads_content + '</li>');
            $('.menu-ads-block-hidden-container').remove();

            $(this).addClass('sub-menu-hover');
            var _close_button = '<li class="custom_menu_close_button section__shell mega-menu-item mega-menu-item-type-post_type mega-menu-item-object-page mega-menu-columns-1-of-1 mega-menu-clear">Close <img src="/wp-content/themes/prestige-theme/images/wiredmedia/chevron-up-white.svg"></li>';
            $(this).append(_close_button);

            // var _level_1_top = $(this).position().top;
            $(this).children('li').each(function(){

                $(this).children('a').each(function(){
                    $(this).addClass('mega-menu-link-level1');
                });

                // var _level_2_top = $(this).position().top;
                $(this).children('ul').each(function(){
                    /** this is sub-menu column-2 **/
                    $(this).addClass('sub-menu-hover');
                    $(this).addClass('force-hide-sub-menu1');

                    var _menu_group_id = Math.floor(Math.random() * 99999);
                    var _child_count = $(this).children('li').length;
                    var _current_child = 0;
                    $(this).children('li').each(function(){
                        if(_child_count > 9){
                            _current_child++;

                            if($(this).hasClass('.menu_scroll_controller')){
                                //-- do not add scroll class
                            }
                            else if(_current_child <= 9){
                                $(this).addClass('menu_scroll_show');
                            }
                            else{
                                $(this).addClass('menu_scroll_hide_bottom');
                            }
                        }

                        $(this).children('a').each(function(){
                            $(this).addClass('mega-menu-link-level2');
                        });

                        $(this).children('ul').each(function(){
                            /** this is sub-menu column-3 **/
                            $(this).addClass('sub-menu-hover');
                            $(this).addClass('force-hide-sub-menu2');

                            $(this).children('li').each(function(){
                                $(this).children('ul').each(function(){
                                    /** this is sub-menu column-4 **/
                                    $(this).addClass('sub-menu-hover');
                                    $(this).addClass('force-hide-sub-menu3');
                                });
                            });
                        });
                    });

                    if(_child_count > 9){
                        $(this).addClass('menu-group-' + _menu_group_id);

                        var _append_scroll_control = '<li class="menu_scroll_controller" data-menugroup="' + _menu_group_id + '">';
                        _append_scroll_control += '<span class="inactive menu_scroll_controller_up"><img src="/wp-content/themes/prestige-theme/images/wiredmedia/chevron-up-white.svg"></span>';
                        _append_scroll_control += '<span class="down menu_scroll_controller_down"><img src="/wp-content/themes/prestige-theme/images/wiredmedia/chevron-up-white.svg"></span>';
                        _append_scroll_control += '</li>';
                        $(this).append(_append_scroll_control);
                    }
                });
            });
        });

        $('.menu_scroll_controller_up').on('click', function(){
            var _menu_group_id = $(this).parent().data('menugroup');
            var _visible_children = $('.menu-group-' + _menu_group_id).children('.menu_scroll_show');
            var _hidden_children = $('.menu-group-' + _menu_group_id).children('.menu_scroll_hide_top');
            if(_hidden_children.length > 0){
                _visible_children.last().removeClass('menu_scroll_show').addClass('menu_scroll_hide_bottom');
                _hidden_children.last().removeClass('menu_scroll_hide_top').addClass('menu_scroll_show');

                $('.menu_scroll_controller_down').removeClass('inactive');
                if(_hidden_children.length <= 1){
                    $('.menu_scroll_controller_up').addClass('inactive');
                }
            }
        });

        $('.menu_scroll_controller_down').on('click', function(){
            var _menu_group_id = $(this).parent().data('menugroup');
            var _visible_children = $('.menu-group-' + _menu_group_id).children('.menu_scroll_show');
            var _hidden_children = $('.menu-group-' + _menu_group_id).children('.menu_scroll_hide_bottom');
            if(_hidden_children.length > 0){
                _visible_children.first().removeClass('menu_scroll_show').addClass('menu_scroll_hide_top');
                _hidden_children.first().removeClass('menu_scroll_hide_bottom').addClass('menu_scroll_show');

                $('.menu_scroll_controller_up').removeClass('inactive');
                if(_hidden_children.length <= 1){
                    $('.menu_scroll_controller_down').addClass('inactive');
                }
            }
        });

        $('.custom_menu_close_button').click(function() {
            $('.mega-sub-menu').mouseleave();

            $('.force-show-sub-menu1').each(function(){
                $(this).addClass('force-hide-sub-menu1').removeClass('force-show-sub-menu1');
            });

            $('.force-show-sub-menu2').each(function(){
                $(this).addClass('force-hide-sub-menu2').removeClass('force-show-sub-menu2');
            });

            $('.force-show-sub-menu3').each(function(){
                $(this).addClass('force-hide-sub-menu3').removeClass('force-show-sub-menu3');
            });

            $('.menu-ads-block-floating-container').show();
        });

        var _mega_menu_open_timeout = null;
        $('.mega-menu-wrap > ul > li > a').on("mouseenter", function(){
            if($(this).next().hasClass("mega-sub-menu")){
                clearTimeout(_mega_menu_open_timeout);
                $('.header-wired').addClass('mega-menu-open');
                $('.page-head').addClass('scrolled-nav');
            }
        })
        .on("mouseleave", function(){
            if($(this).next().hasClass("mega-sub-menu")){
                _mega_menu_open_timeout = setTimeout(function(){
                    $('.header-wired').removeClass('mega-menu-open');
                    unloadScrolledNav();
                }, 300);
            }
        });

        $('.mega-menu-wrap > ul > li > ul').on("mouseenter", function(){
            clearTimeout(_mega_menu_open_timeout);
            $('.header-wired').addClass('mega-menu-open');
            $('.page-head').addClass('scrolled-nav');
        })
        .on("mouseleave", function(){
            _mega_menu_open_timeout = setTimeout(function(){
                $('.header-wired').removeClass('mega-menu-open');
                unloadScrolledNav();
            }, 300);
        });

        $('.sub-menu-hover').on("mouseenter", function(){
            $(this).prev('a').addClass('hover-effect-on');
        })
        .on("mouseleave", function(){
            $(this).prev('a').removeClass('hover-effect-on');
        });

        var _menu_timeout = null;
        $('.mega-menu-link').on("mouseenter", function(){
            clearTimeout(_menu_timeout);
            var _this = this;

            if($(this).next('.force-hide-sub-menu1').length > 0){
                if($('.force-show-sub-menu1').length > 0){
                    _menu_timeout = setTimeout(function(){
                        $('.force-show-sub-menu1').each(function(){
                            $(this).addClass('force-hide-sub-menu1').removeClass('force-show-sub-menu1');
                        });
                        $('.force-show-sub-menu2').each(function(){
                            $(this).addClass('force-hide-sub-menu2').removeClass('force-show-sub-menu2');
                        });
                        $('.force-show-sub-menu3').each(function(){
                            $(this).addClass('force-hide-sub-menu3').removeClass('force-show-sub-menu3');
                        });
                        $(_this).next('.sub-menu-hover').removeClass('force-hide-sub-menu1').addClass('force-show-sub-menu1');

                        $('.menu-ads-block-floating-container').show();
                    }, 300);
                }
                else{
                    $(_this).next('.sub-menu-hover').removeClass('force-hide-sub-menu1').addClass('force-show-sub-menu1');
                }
            }
            else if($(this).next('.force-hide-sub-menu2').length > 0){
                if($('.force-show-sub-menu2').length > 0){
                    _menu_timeout = setTimeout(function(){
                        $('.force-show-sub-menu2').each(function(){
                            $(this).addClass('force-hide-sub-menu2').removeClass('force-show-sub-menu2');
                        });
                        $('.force-show-sub-menu3').each(function(){
                            $(this).addClass('force-hide-sub-menu3').removeClass('force-show-sub-menu3');
                        });
                        $(_this).next('.sub-menu-hover').removeClass('force-hide-sub-menu2').addClass('force-show-sub-menu2');

                        $('.menu-ads-block-floating-container').hide();
                    }, 300);
                }
                else{
                    $(_this).next('.sub-menu-hover').removeClass('force-hide-sub-menu2').addClass('force-show-sub-menu2');
                    $('.menu-ads-block-floating-container').hide();
                }
            }
            else if($(this).next('.force-hide-sub-menu3').length > 0){
                if($('.force-show-sub-menu3').length > 0){
                    _menu_timeout = setTimeout(function(){
                        $('.force-show-sub-menu3').each(function(){
                            $(this).addClass('force-hide-sub-menu3').removeClass('force-show-sub-menu3');
                        });
                        $(_this).next('.sub-menu-hover').removeClass('force-hide-sub-menu3').addClass('force-show-sub-menu3');
                    }, 300);
                }
                else{
                    $(_this).next('.sub-menu-hover').removeClass('force-hide-sub-menu3').addClass('force-show-sub-menu3');
                }
            }
            else{
                if($(this).hasClass('mega-menu-link-level1')){
                    _menu_timeout = setTimeout(function(){
                        if($(_this).next('.force-show-sub-menu1').length == 0){
                            $('.force-show-sub-menu1').each(function(){
                                $(this).addClass('force-hide-sub-menu1').removeClass('force-show-sub-menu1');
                            });
                        }
                        $('.force-show-sub-menu2').each(function(){
                            $(this).addClass('force-hide-sub-menu2').removeClass('force-show-sub-menu2');
                        });
                        $('.force-show-sub-menu3').each(function(){
                            $(this).addClass('force-hide-sub-menu3').removeClass('force-show-sub-menu3');
                        });

                        $('.menu-ads-block-floating-container').show();
                    }, 300);
                }
                else if($(this).hasClass('mega-menu-link-level2')){
                    _menu_timeout = setTimeout(function(){
                        if($(_this).next('.force-show-sub-menu2').length == 0){
                            $('.force-show-sub-menu2').each(function(){
                                $(this).addClass('force-hide-sub-menu2').removeClass('force-show-sub-menu2');
                                $('.menu-ads-block-floating-container').show();
                            });
                        }
                        $('.force-show-sub-menu3').each(function(){
                            $(this).addClass('force-hide-sub-menu3').removeClass('force-show-sub-menu3');
                        });
                    }, 300);
                }
                else if($(this).hasClass('mega-menu-link-level3')){
                    _menu_timeout = setTimeout(function(){
                        if($(_this).next('.force-show-sub-menu2').length == 0){
                            $('.force-show-sub-menu3').each(function(){
                                $(this).addClass('force-hide-sub-menu3').removeClass('force-show-sub-menu3');
                            });
                        }
                    }, 300);
                }
            }
        });

        /** viewpport checker for animation when element become visible in the screen - start **/
        /*$('.viewport-animate-fade-up').viewportChecker({
            // Class to add to the elements when they are visible
            classToAdd: 'animate-fade-up',

            // The offset of the elements (let them appear earlier or later)
            offset: 100,

            // Add the possibility to remove the class if the elements are not visible
            repeat: false,

            // Callback to do after a class was added to an element. Action will return "add" or "remove", depending if the class was added or removed
            callbackFunction: function(elem, action){}
        });
         */
        /*
        $('.viewport-animate-hover-effect').viewportChecker({
            // Class to add to the elements when they are visible
            classToAdd: 'animate-hover-effect',

            // The offset of the elements (let them appear earlier or later)
            offset: 300,

            // Add the possibility to remove the class if the elements are not visible
            repeat: false,

            // Callback to do after a class was added to an element. Action will return "add" or "remove", depending if the class was added or removed
            callbackFunction: function(elem, action){}
        });
         */
        /** viewpport checker for animation when element become visible in the screen - end **/

        /** JS for block animations - start */
        /*
        $('.viewport-animate-fadein-expand').viewportChecker({
            classToAdd: 'animate-fadein-expand',
            offset: 100,
            repeat: false,
            callbackFunction: function(elem, action){}
        });
        */
        /** JS for block animations - end */

    }, 800);
    /** JS for customize mega menu for desktop - end */

    /** JS for customize menu for mobile - start */
    $('.main-nav-prestige > div > ul').each(function() {
        removeMenuItemWithChildrenLink(this);
    });

    $('.menu-item-has-children').click(function() {
        if($(this).hasClass('active')){
            $(this).parent().addClass('menu-list-active');
            $(this).parent().addClass('menu-list-active-overflow');
        }
        else if(!$(this).find('ul').hasClass('menu-list-active')){
            var _this = this;
            $(_this).parent().removeClass('menu-list-active');
            setTimeout(function(){
                $(_this).parent().removeClass('menu-list-active-overflow');
            }, 300);
        }
    });

    $('.menu-item-back').click(function() {
        var _this = this;
        setTimeout(function(){
            $(_this).parent().parent().removeClass('active');
            $(_this).parent().parent().parent().removeClass('menu-list-active');
        }, 200);

        $(this).parent().parent().removeClass('active');
        $(this).parent().parent().parent().removeClass('menu-list-active');
    });

    $('.menu-item-link').click(function() {
        var _href = $(this).attr('href');
        if(_href != '' && _href != '#' && _href != 'javascript:void(0);'){
            location.href = _href;
        }

        hideMenu();
    });
    /** JS for customize menu for mobile - end */

    var _gform_validated = true;
    var _gform_current = null;
    $('.gform-button').click(function(){
        _gform_validated = true;
        _gform_current = $(this).closest("form");
        $(_gform_current).find('.custom_contact_form_required_field').each(function(){
            var _message_id =  $(this).attr('id').replace('field_', 'validation_message_');
            if($('#' + _message_id).length > 0){
                $('#' + _message_id).remove();
            }

            if($(this).find('input').val() == ""){
                _gform_validated = false;
                $(this).append('<div id="' + _message_id + '" class="gfield_description validation_message gfield_validation_message">This field is required.</div>');
            }
        });

        var _validation_container = $(_gform_current).attr('id') + '_validation_container';
        if($('#' + _validation_container).length > 0){
            $('#' + _validation_container).remove();
        }

        if(_gform_validated){
            $(_gform_current).submit();
        }
        else{
            $(_gform_current).before('<div class="gform_validation_errors" id="' + _validation_container + '"><h2 class="gform_submission_error">There was a problem with your submission.<br>Please review the fields below.</h2></div>');
        }

        return _gform_validated;
    });
}

function removeMenuItemWithChildrenLink(_this){
    $(_this).children('li').each(function(){
        $(this).children('a').each(function(){
            $(this).addClass('menu-item-link');
        });

        if($(this).hasClass('menu-item-has-children')){
            var _text = "";
            $(this).children('a').each(function(){
                $(this).attr('href', 'javascript:void(0);');
                $(this).removeClass('menu-item-link');
                _text = $(this).html();
            });

            $(this).children('ul').each(function(){
                // $(this).addClass('menu-item-column');
                removeMenuItemWithChildrenLink(this);

                $(this).prepend('<li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-back"><a href="javascript:void(0);">' + _text + '</a></li>')
            });
        }
    });
}

function initBlogFilterEvents(){
    /** JS for Blog Pager - Start **/
    $('.pager-container > .pager-select').unbind('change');
    $('.pager-container > .pager-select').change(function() {
        var _slug = $(this).data('slug');
        var _page = $(this).val();
        var _paged = "";
        if(_page > 1){
            _paged = '/page/' + _page;
        }

        location.href = '/' + _slug + _paged + getBlogFiltersParams();
    });

    $('.pager-container > .pager-start').unbind('change');
    $('.pager-container > .pager-start').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        location.href = '/' + _slug  + getBlogFiltersParams();
    });

    $('.pager-container > .pager-prev').unbind('change');
    $('.pager-container > .pager-prev').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').val();
        _page--;
        var _paged = "";
        if(_page > 1){
            _paged = '/page/' + _page;
        }
        location.href = '/' + _slug + _paged + getBlogFiltersParams();
    });

    $('.pager-container > .pager-next').unbind('change');
    $('.pager-container > .pager-next').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').val();
        _page++;
        location.href = '/' + _slug + '/page/' + _page + getBlogFiltersParams();
    });

    $('.pager-container > .pager-end').unbind('change');
    $('.pager-container > .pager-end').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $('.pager-container > .pager-select').data('maxpage');
        var _paged = "";
        if(_page > 1){
            _paged = '/page/' + _page;
        }
        location.href = '/' + _slug + _paged + getBlogFiltersParams();
    });

    $('.pager-container > .pager-goto').unbind('change');
    $('.pager-container > .pager-goto').click(function() {
        if($(this).hasClass('pager-disabled'))
            return false;

        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = $(this).data('page');
        var _paged = "";
        if(_page > 1){
            _paged = '/page/' + _page;
        }
        location.href = '/' + _slug + _paged + getBlogFiltersParams();
    });
    /** JS for Blog Pager - End **/

    $('#filter_search').unbind('keyup');
    $('#filter_search').keyup(function(e){
        if(e.which == 13){
            var _slug = $('.pager-container > .pager-select').data('slug');
            var _page = 1; //-- when pressing enter on search field always go to page 1
            var _paged = "";
            if(_page > 1){
                _paged = '/page/' + _page;
            }

            location.href = '/' + _slug + _paged + getBlogFiltersParams();
        }
    });

    $('.blog_filter_button').unbind('click');
    $('.blog_filter_button').click(function(){
        var _slug = $('.pager-container > .pager-select').data('slug');
        var _page = 1; //-- when pressing search button always go to page 1
        var _paged = "";
        if(_page > 1){
            _paged = '/page/' + _page;
        }

        location.href = '/' + _slug + _paged + getBlogFiltersParams();
    });

    $('.filter_box_toggle').unbind('click');
    $('.filter_box_toggle').click(function(){
        if($(this).hasClass('fa-caret-up')){
            $('.filter_box_toggle').each(function(){
                $(this).replaceWith('<i class="fa fa-caret-down fa-2x filter_box_toggle"></i>');
            });

            $('.filter_hidden').each(function(){
                $(this).slideDown();
            });
        }
        else{
            $('.filter_box_toggle').each(function(){
                $(this).replaceWith('<i class="fa fa-caret-up fa-2x filter_box_toggle"></i>');
            });

            $('.filter_hidden').each(function(){
                $(this).slideUp();
            });
        }
        setTimeout(function(){
            initBlogFilterEvents();
        }, 1000);
    });
}

function getBlogFiltersParams(){
    var _filters = "";
    var _filters_array = [];

    if($('#filter_search').val() != "")
        _filters_array.push('search=' + $('#filter_search').val());

    if(_filters_array.length > 0)
        _filters = "?" + _filters_array.join("&");
    return _filters;
}

var _featured_venues_conflict_prevention = false;
function initMultiSelectDropdown(_id, _label){
    $(_id).multiSelect({

        // Custom templates
        'containerHTML': '<div class="multi-select-container">',
        'menuHTML': '<div class="multi-select-menu">',
        'buttonHTML': '<span class="multi-select-button">',
        'menuItemsHTML': '<div class="multi-select-menuitems">',
        'menuItemHTML': '<label class="multi-select-menuitem">',
        'presetsHTML': '<div class="multi-select-presets">',

        // sets some HTML (eg: <div class="multi-select-modal">) to enable the modal overlay.
        'modalHTML': undefined,

        // Active CSS class
        'activeClass': 'multi-select-container--open',

        // Text to show when no option is selected
        'noneText': _label,

        // Text to show when all options are selected
        'allText': undefined,

        // an array of preset option groups
        // presets: [{
        //   name: 'All categories',
        //   all: true // select all
        // },{
        //   name: 'My categories',
        //   options: ['a', 'c']
        // }]
        'presets': undefined,

        // CSS class added to the container, when the menu is about to extend beyond the right edge of the position<a href="https://www.jqueryscript.net/menu/">Menu</a>Within element
        'positionedMenuClass': 'multi-select-container--positioned',

        // If you provide a jQuery object here, the plugin will add a class (see positionedMenuClass option) to the container when the right edge of the dropdown menu is about to extend outside the specified element, giving you the opportunity to use CSS to prevent the menu extending, for example, by allowing the option labels to wrap onto multiple lines.
        'positionMenuWithin': undefined,

        // The plugin will attempt to keep this distance, in pixels, clear between the bottom of the menu and the bottom of the viewport, by setting a fixed height style if the menu would otherwise approach this distance from the bottom edge of the viewport.
        'viewportBottomGutter': 20,

        // minimal height
        'menuMinHeight': 200

      });
}

function checkMobileHeights(){
    let myResizeCallback = function(){
        $('.mobile_check_height').each((k, v) => {
            let card = $(v).find('.card-wrapper-prestige');
            let H = $(card).outerHeight();
            let top = parseInt($(card).css('top'));
            let tot = H + top;
            $(v).height(tot);
        });
        reveal();
    };
    if(window.innerWidth < MOBILE_WIDTH_TRESHOLD) {
        setTimeout(myResizeCallback, 2000);
    }else{
        document.querySelectorAll('.mobile_check_height').forEach((v) => {
            v.style.removeProperty('height');
        });
    }
}

$(window).resize(function() {
    if(!$('body').hasClass('prestige')) {
        checkTop();
    }

//    fixGalleryTabs();
    if($('.vimeo').length > 0){
        checkVimeo();
    }
    checkMobileHeights();
});

function checkVimeo(){
    var ratio = $('.vimeo').parent().data('ratio');
    var wrapper = $('.vimeo').parent().parent();
    var W = $(wrapper).width();
    var estH = Math.round(W * (1/ratio));
    $(wrapper).height(estH);
}

function fixGalleryTabs(){
    $('.gallery-block .slick-dots').children().gt(4).each(function(k,v){
        $(v).remove();
    });
}

function checkTop(){
    var H = Math.floor($('header.page-head').outerHeight() - 1);
    $('.flexible-content-wrap-premium').css('paddingTop', H+'px');

    var W = $(window).width();
    var calc;
    if(W <= 750){
        calc = 'calc(50vh - '+H+'px)';
    }else{
        calc = 'calc(100vh - '+H+'px)';
    }
    $('.hero-block-wrapper img').css('height', calc);
    $('.hero-block-wrapper .videowrapper').css('height', calc);
    $('.hero-block-wrapper .videoplayer').css('height', calc);
    $('.hero-block-wrapper .overlay-wrapper').css('height', calc);

}

function convertUKDateStringToUSDateString(date){

    var dateParts = date.split("/");

    var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

    return dateObject.toString();
}

if($('.hero-book').length > 0) {
    var fixmeTop = $('.hero-book').offset().top - $("header.page-head").height(); // get initial position of the element
    $(window).scroll(function () {
        var currentScroll = $(window).scrollTop();

        if (currentScroll >= fixmeTop) {
            $('.hero-book').css({
                position: 'fixed',
                bottom: '0',
                top: 'auto'

            });
        } else {
            $('.hero-book').removeAttr("style");
        }

    });
}

function showMenu() {
    $('.mega-menu-wrap').hide();
    $('.menu-overlay').addClass('active');
    $('.menu-btn-close').addClass('active');
}
function hideMenu() {
    $('.mega-menu-wrap').show();
    $('.menu-overlay').removeClass('active');
    $('.menu-btn-close').removeClass('active');

    $('.menu-list-active').each(function(){
        $(this).removeClass('menu-list-active');
        $(this).removeClass('menu-list-active-overflow');
    });

    $('.menu-item-has-children').each(function(){
        $(this).removeClass('active');
    });
}

function scrollNext(el, _parent_class){
    let curRef = $(el).data('ref');
    if(typeof curRef === 'undefined'){
        let dest = $(el).closest(_parent_class).next();
        let newId = "id-"+Math.floor(Math.random() * 999);

        if($(dest).is("style")){
            dest = $(el).closest(_parent_class).next().next();
            $(dest).attr('id', newId);
        }

        let curID = $(dest).attr('id');
        if(typeof curID === 'undefined'){
            dest = $(el).next(_parent_class).next();
            curID = $(dest).attr('id');
        }
        if(typeof curID === 'undefined'){
            dest = $(_parent_class).next();
            curID = $(dest).attr('id');
        }
        if(typeof curID === 'undefined'){
            $(dest).attr('id', newId);
            curRef = '#'+newId;
        }
        else{
            curRef = '#'+curID;
        }
        $(el).data('ref', curRef);
    }
    $('html, body').animate({
        scrollTop: $(curRef).offset().top
    }, 800, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = curRef;
    });
}

function scrollToId(_id){
    $('html, body').animate({
        scrollTop: $('#' + _id).offset().top
    }, 800, function(){
        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = _id;
    });
}

function reveal() {
    var reveals = document.querySelectorAll(".reveal");
    for (var i = 0; i < reveals.length; i++) {
        var windowHeight = window.innerHeight;
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 50;
        if (elementTop < windowHeight - elementVisible) {
            reveals[i].classList.add("active");
        } else {
            reveals[i].classList.remove("active");
        }
    }

    reveals = document.querySelectorAll(".reveal-no-fade");
    for (var i = 0; i < reveals.length; i++) {
        var windowHeight = window.innerHeight;
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 50;
        if (elementTop < windowHeight - elementVisible) {
            reveals[i].classList.add("active");
        } else {
            reveals[i].classList.remove("active");
        }
    }
}